<template>
  <!-- Slider -->
  <div class="grid grid-cols-1">
    <Slider />
  </div>

  <!-- Kalkulator -->
  <div class="py-10">
    <div class="container mx-auto grid grid-cols-1 p-3 sm:w-full md:w-5/12">
      <div class="bg-white rounded-md shadow-md p-3">
        <h1 class="font-bold text-center uppercase text-xl pt-5">
          Kalkulator Zakat
        </h1>
        <p class="py-3 text-justify">
          Kalkulator zakat adalah layanan untuk mempermudah perhitungan jumlah
          zakat yang harus ditunaikan oleh setiap umat muslim sesuai ketetapan
          syariah. Oleh karena itu, bagi Anda yang ingin mengetahui berapa
          jumlah zakat yang harus ditunaikan, silahkan gunakan fasilitas
          Kalkulator Zakat BAZNAS dibawah ini.
        </p>
        <hr class="pb-3" />
        <label for="jenis" class="">Jenis Zakat</label>
        <select
          v-model="selected"
          name="jenis"
          id="jenis"
          class="block border w-full p-3 mb-3"
        >
          <option value="zakatPenghasilan">Zakat Penghasilan</option>
          <option value="zakatMal">Zakat Mal</option>
        </select>
        <div v-if="selected == 'zakatPenghasilan'">
          <p class="mb-3 text-justify">
            Zakat penghasilan atau yang dikenal juga sebagai zakat profesi
            adalah bagian dari zakat maal yang wajib dikeluarkan atas harta yang
            berasal dari pendapatan / penghasilan rutin dari pekerjaan yang
            tidak melanggar syariah. Nishab zakat penghasilan sebesar 85 gram
            emas per tahun. Kadar zakat penghasilan senilai 2,5%. Dalam
            praktiknya, zakat penghasilan dapat ditunaikan setiap bulan dengan
            nilai nishab per bulannya adalah setara dengan nilai seperduabelas
            dari 85 gram emas, dengan kadar 2,5%. Jadi apabila penghasilan
            setiap bulan telah melebihi nilai nishab bulanan, maka wajib
            dikeluarkan zakatnya sebesar 2,5% dari penghasilannya tersebut.
            (Sumber: Al Qur'an Surah Al Baqarah ayat 267, Peraturan Menteri
            Agama Nomer 31 Tahun 2019, Fatwa MUI Nomer 3 Tahun 2003, dan
            pendapat Shaikh Yusuf Qardawi).
          </p>
          <label for="jumlahPendapatan"
            >Jumlah pendapatan per bulan
            <span class="text-xs text-red-500 opacity-50"
              >*masukkan 0 jika tidak ada</span
            ></label
          >
          <input
            required
            v-model="number.penghasilan"
            type="number"
            placeholder="Masukkan jumlah (contoh: 10000)"
            id="jumlahPendapatan"
            class="block border w-full p-3 mb-3"
          />
          <label for="bonus"
            >Bonus, THR, dan lainnya
            <span class="text-xs text-red-500 opacity-50"
              >*masukkan 0 jika tidak ada</span
            ></label
          >
          <input
            required
            v-model="number.bonus"
            type="number"
            placeholder="Masukkan bonus (contoh: 10000)"
            id="bonus"
            class="block border w-full p-3 mb-3"
          />
          <button
            @click="hitungZakatPenghasilan(number.penghasilan, number.bonus)"
            class="bg-hijau w-full py-3 font-bold text-white rounded-md mb-5"
          >
            Hitung Zakat
          </button>
          <div>
            <h3 class="text-center font-bold uppercase">Hasil</h3>
            <h2 class="text-xl font-bold uppercase text-center py-3">
              Rp. {{ formatPrice(number.amount) }}
            </h2>
          </div>
        </div>
        <div v-else-if="selected == 'zakatMal'">
          <p class="mb-3 text-justify">
            Zakat maal yang dimaksud dalam perhitungan ini adalah zakat yang
            dikenakan atas uang, emas, surat berharga, dan aset yang disewakan.
            Tidak termasuk harta pertanian, pertambangan, dan lain-lain yang
            diatur dalam UU No.23/2011 tentang pengelolaan zakat. Zakat maal
            harus sudah mencapai nishab (batas minimum) dan terbebas dari hutang
            serta kepemilikan telah mencapai 1 tahun (haul). Nishab zakat maal
            sebesar 85 gram emas. Kadar zakatnya senilai 2,5%. (Sumber: Al
            Qur'an Surah Al Baqarah ayat 267, Peraturan Menteri Agama Nomer 31
            Tahun 2019, Fatwa MUI Nomer 3 Tahun 2003, dan pendapat Shaikh Yusuf
            Qardawi). Standar harga emas yg digunakan untuk 1 gram nya adalah
            Rp938.099,-. Sementara nishab yang digunakan adalah sebesar 85 gram
            emas.
          </p>
          <label for="emas"
            >Nilai emas, perak, dan/atau permata
            <span class="text-xs text-red-500 opacity-50"
              >*masukkan 0 jika tidak ada</span
            ></label
          >
          <input
            required
            v-model="number2.emas"
            type="number"
            placeholder="Masukkan jumlah (contoh: 10000)"
            id="emas"
            class="block border w-full p-3 mb-3"
          />
          <label for="uangTunai"
            >Uang tunai, tabungan, deposito
            <span class="text-xs text-red-500 opacity-50"
              >*masukkan 0 jika tidak ada</span
            ></label
          >
          <input
            required
            v-model="number2.uangTunai"
            type="number"
            placeholder="Masukkan bonus (contoh: 10000)"
            id="uangTunai"
            class="block border w-full p-3 mb-3"
          />
          <label for="kendaraan"
            >Kendaraan, rumah, aset lain
            <span class="text-xs text-red-500 opacity-50"
              >*masukkan 0 jika tidak ada</span
            ></label
          >
          <input
            required
            v-model="number2.kendaraan"
            type="number"
            placeholder="Masukkan jumlah (contoh: 10000)"
            id="kendaraan"
            class="block border w-full p-3 mb-3"
          />
          <label for="hutang"
            >Jumlah hutang/cicilan(optional)
            <span class="text-xs text-red-500 opacity-50"
              >*masukkan 0 jika tidak ada</span
            ></label
          >
          <input
            required
            v-model="number2.hutang"
            type="number"
            placeholder="Masukkan jumlah (contoh: 10000)"
            id="hutang"
            class="block border w-full p-3 mb-3"
          />
          <button
            @click="
              hitungZakatMal(
                parseInt(number2.emas),
                parseInt(number2.uangTunai),
                parseInt(number2.kendaraan),
                parseInt(number2.hutang)
              )
            "
            class="bg-hijau w-full py-3 font-bold text-white rounded-md mb-5"
          >
            Hitung Zakat
          </button>
          <div>
            <h3 class="text-center font-bold uppercase">Hasil</h3>
            <h2 class="text-xl font-bold uppercase text-center py-3">
              Rp. {{ formatPrice(number2.amount) }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <WhatsappButton />
</template>

<script>
// slider
import Slider from "@/components/Slider.vue";

// whatsapp button
import WhatsappButton from "@/components/WhatsappButton.vue";

//hook vue
import { reactive } from "vue"; // computed dan onMounted

export default {
  data() {
    return {
      selected: "",
    };
  },
  components: {
    Slider, // slider
    WhatsappButton, // Whatsappbutton
  },

  setup() {
    const number = reactive({
      amount: 0,
      penghasilan: 0,
      bonus: 0,
    });

    const number2 = reactive({
      amount: 0,
      emas: 0,
      uangTunai: 0,
      kendaraan: 0,
      hutang: 0,
    });

    function hitungZakatPenghasilan(penghasilan, bonus = 0) {
      number.amount = 0;

      if (number.penghasilan * 12 >= 77520000) {
        bonus > 0
          ? (number.amount =
              ((parseInt(penghasilan) + parseInt(bonus)) * 2.5) / 100)
          : (number.amount = (parseInt(penghasilan) * 2.5) / 100);
        return;
      }
      number.amount =
        "Cukup berinfak/bershadaqah saja. Tidak wajib untuk zakat";
    }

    function hitungZakatMal(emas, uangTunai, kendaraan, hutang = 0) {
      number2.amount = 0;
      if (emas + uangTunai + kendaraan - hutang >= 77520000) {
        number2.amount = ((emas + uangTunai + kendaraan - hutang) * 2.5) / 100;
        console.log(number2.amount);
        return;
      }
      number2.amount =
        "Cukup berinfak/bershadaqah saja. Tidak wajib untuk zakat";
    }

    return {
      number,
      number2,
      hitungZakatPenghasilan,
      hitungZakatMal,
    };
  },
};
</script>